import { faqContactForm, i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";
import { toggleContactForm } from "./toggleContactForm.js";

/**
 * Displays the FAQ answer based on the selected section key and element value.
 *
 * @param {string} sectionKey - The key of the FAQ section.
 * @param {HTMLElement} Elem - The element triggering the display of the FAQ answer.
 * @returns {void}
 */
export function displayFaqAnswer(sectionKey, Elem) {
    const faqAnswerElem = document.getElementById("faqAnswer");
    if (faqAnswerElem) {
        faqAnswerElem.remove();
    }

    const faqConfirmElem = document.getElementById("faqConfirm");
    if (faqConfirmElem) {
        faqConfirmElem.remove();
    }
    if (Elem.value === "") {
        toggleContactForm();
        return;
    }
    const answerHTML = faqContactForm.faq[sectionKey][Elem.value];
    const faqAnswer = createElement(
        "div",
        { class: "form-group", id: "faqAnswer" },
        [
            createElement(
                "label",
                { for: "faqAnswer" },
                [],
                i18n.getTranslation("contact_us_rel_faqs")
            ),
            createElement(
                "div",
                { class: "form-control", id: "faqAnswer" },
                [],
                answerHTML
            ),
        ]
    );

    const faqConfirm = createElement(
        "div",
        { class: "form-group", id: "faqConfirm" },
        [
            createElement(
                "label",
                { for: "faqConfirm" },
                [],
                i18n.getTranslation("contact_us_confirm")
            ),
            createElement("div", { class: "form-check" }, [
                createElement(
                    "input",
                    {
                        class: "form-check-input",
                        type: "radio",
                        name: "faqConfirm",
                        id: "faqConfirmYes",
                        value: "Yes",
                        checked: true,
                    },
                    []
                ),
                createElement(
                    "label",
                    { class: "form-check-label", for: "faqConfirmYes" },
                    [],
                    i18n.getTranslation("yes")
                ),
            ]),
            createElement("div", { class: "form-check" }, [
                createElement(
                    "input",
                    {
                        class: "form-check-input",
                        type: "radio",
                        name: "faqConfirm",
                        id: "faqConfirmNo",
                        value: "No",
                        // onchange: "toggleContactForm()"
                    },
                    [],
                    "",
                    {
                        change: (event) => {
                            toggleContactForm();
                        },
                    }
                ),
                createElement(
                    "label",
                    { class: "form-check-label", for: "faqConfirmNo" },
                    [],
                    i18n.getTranslation("no")
                ),
            ]),
        ]
    );

    Elem.parentElement.parentElement.appendChild(faqAnswer);
    Elem.parentElement.parentElement.appendChild(faqConfirm);
}
